import './css/estudiantes.css';
import axios from 'axios';
import { useEffect, useState } from 'react';
import Espera from '../Espera';
import PerfilLogo from '../usuarios/PerfilLogo.js';
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { show_alerta } from '../../funciones.js';

import CONFIG from '../../config';
import MostrarEncabezadoInstancias from './MostrarEncabezadoInstancias.js';
import MostrarEncabezadosActividades from './MostrarEncabezadosActividades.js';

import EstadisticaAsistencia from './EstadisticaAsistencia.js';
import GraficoAsistencia from './GraficoAsistencia.js';
import VerEntrega from './VerEntrega.js';

const URL = `${CONFIG.API_URL}/operarEstudiantes.php`;
const URL_CALIFICACIONES = `${CONFIG.API_URL}/operarValoraciones.php`;
const URL_ASISTENCIA = `${CONFIG.API_URL}/operarAsistencia.php`;
const URL_ACTIVIDADES = `${CONFIG.API_URL}/operarActividades.php`;

function Estudiantes({ acceder, rol }) {
    const [estudiantes, setEstudiantes] = useState([]);
    const [valoraciones, setValoraciones] = useState([]); // para traer las Valoraciones de la BD
    const [colInstancias, setColInstancias] = useState([]); // para traer las instancias de evaluacion de la BD

    const [asistencia, setAsistencia] = useState([]); //para trar la asistencia por fecha de la BD
    const [asistenciaAnual, setAsistenciaAnual] = useState([]); //para trar la asistencia anual de la BD

    const [actividades, setActividades] = useState([]); //para trar la asistencia de la BD

    const [formValues, setFormValues] = useState({}); // Para almacenar los valores seleccionados de los select notas
    const [formValuesAsistencia, setFormValuesAsistencia] = useState({}); // Para almacenar los valores seleccionados de los select asistencia

    const [visible, setVisible] = useState(false);
    const [vista, setVista] = useState('calificaciones'); // Estado para controlar la vista activa

    const [fechaHoy, setFechaHoy] = useState(() => new Date().toISOString().split('T')[0]); //fecha de hoy
    const [fechaSeleccionada, setFechaSeleccionada] = useState(fechaHoy); //iniciafecha de hoy
    
    const navigate = useNavigate();
    const loggeduserCurso = localStorage.getItem('loggeduserCurso');
    const loggeduserCursoGrupo = localStorage.getItem('loggeduserCursoGrupo');
    const loggeduserId = localStorage.getItem('loggeduserId');

    const [entregaSeleccionada, setEntregaSeleccionada] = useState(null);
    



    useEffect(() => {
        if (acceder) {
            if (rol === null) {
                navigate("/");
            } else {  
                const data = {
                    'id_curso': loggeduserCurso,
                    'id_grupo': loggeduserCursoGrupo,
                    'modo': 'buscarEstudiantesCurso'
                };
                obtenerEstudiantesyValoraciones(data);
                
                obtenerAsistencia();
                obtenerActividades();
            }
        } else {
            localStorage.clear();
            navigate('/');
        }                   
    }, [acceder, rol, navigate, loggeduserCurso, loggeduserCursoGrupo]);

    useEffect(() => {
        if (vista === 'asistencia') {
            obtenerAsistencia();
            setFormValuesAsistencia({}); // Limpia los selects
        }
    }, [fechaSeleccionada, vista]);

    //funcion para  poner todos los estudiantes conpresente antes de guardar
    const marcarTodosComoPresentes = () => {
        const nuevosValores = { ...formValuesAsistencia };

        estudiantes.forEach(est => {
            const yaTieneAsistencia = asistencia.find(a => a.id_usuario === est.id && a.fecha === fechaSeleccionada);
            if (!yaTieneAsistencia) {
                nuevosValores[`${est.id}_`] = {
                    id_usuario: est.id,
                    valor: 'Presente'
                };
            }
        });
        setFormValuesAsistencia(nuevosValores);
    };

    //funcion para obtener los estudiantes y sus valoraciones
    const obtenerEstudiantesyValoraciones = (dato) => {
        setVisible(true);
        axios.post(URL, dato)
        .then(res => {
            if (!res.data.error) {
                //console.log("estudiantes:"+res.data.valoraciones); 
                setEstudiantes(res.data.estudiantes);
                setValoraciones(res.data.valoraciones);
            } else {
                setEstudiantes([]);
                setValoraciones([]);
            }
            setVisible(false);
        })
        .catch(err => {
            console.log(err);
        });
    }

    //funcion para obtener la asistencia 
    const obtenerAsistencia = () => {
        const dataAsistencia = {
            modo: 'obtenerAsistencia',
            fecha: fechaSeleccionada,
            curso: loggeduserCursoGrupo
        };
        axios.post(URL_ASISTENCIA, dataAsistencia)
        .then(res => {
            if (!res.data.error) {
                console.log('asis:'+JSON.stringify(res.data));
                setAsistencia(res.data.asistencias);
                setAsistenciaAnual(res.data.asistencias_anual);
            } else {
                setAsistencia([]);
                setAsistenciaAnual([]);
            }
        })
        .catch(err => {
            console.error('Error al obtener asistencia:', err);
        });
    }

    //funcion para obtener las actividades 
    const obtenerActividades = () => {
       
        axios.get(`${URL_ACTIVIDADES}?id_curso_grupo=${loggeduserCursoGrupo}&rol=${rol}`)
        .then(res => {
            //console.log("aaaaaaaaaaa:"+`${URL_ACTIVIDADES}?id_curso=${loggeduserCursoGrupo}&rol=${rol}`);
            if(res.data.success){
                console.log('activ:'+JSON.stringify(res.data));
                setActividades(res.data.actividades);
            } else {
                setActividades([]);
            }
        })
        .catch(err => {
            console.error('Error al obtener asistencia:', err);
        });
    }

    // Función para manejar el cambio de vista
    const handleVistaChange = (nuevaVista) => {
        setVista(nuevaVista);
    }

    
    const eliminarEstudiante = (id) =>{
        const MySwal= withReactContent(Swal); 
        MySwal.fire({
            title: '¿Seguro de Quitar al/la estudiante de la clase?',
            icon: 'question', 
            text: 'si desea volvera ingresarlo lo debera hacer el administrador',
            showCancelButton: true, confirmButtonText: 'Si, eliminar', cancelButtonText: 'Cancelar'
        })
        .then(res=>{
            if(res.isConfirmed){
                enviarSolicitud('DELETE',{'id':id,'id_grupo': loggeduserCursoGrupo,'modo': 'eliminarEstudiante'})
            }
            else{
                show_alerta(' NO fue eliminado');
            }
        });
    };

    const enviarSolicitud = async (metodo, parametros) =>{
        setVisible(true);
        await axios({method:metodo, url:URL, data:parametros})
            .then(res => {
                if (!res.data.error) {
                    // Filtra al estudiante eliminado de la lista
                    setEstudiantes(estudiantes.filter(e => e.id !== parametros.id));
                    console.log(res.data);
                    var tipo = res.data[0];
                    var msj = res.data[1];
                    show_alerta(msj,tipo);    
                } else {
                    alert('Error al eliminar al estudiante');
                }
                setVisible(false);
            })
            .catch(err => {
                show_alerta('Error en la solicitud ','error');
                console.log(err);
                setVisible(false);
            });
    };
    
    // Manejar cambios en los select de notas
    const handleSelectChange = (idUsuario, idInstancia, valor) => {
        console.log('usuario:'+idUsuario+'instancia:'+idInstancia+'valor:'+valor);
        setFormValues((prev) => ({
            ...prev,
            [`${idUsuario}_${idInstancia}`]: { id_usuario: idUsuario, id_instancia: idInstancia, valor: valor }
        }));
    };

    // Manejar cambios en los select de asistencia
    const handleSelectInasistenciaChange = (idUsuario, valor) => {
        //console.log('usuario:'+idUsuario+' valor:'+valor);
        setFormValuesAsistencia((prev) => ({
            ...prev,
            [`${idUsuario}_`]: { id_usuario: idUsuario, valor: valor }
        }));
    };

    // Enviar valores al backend
    const handleSubmit = async (e) => {
        e.preventDefault();
        if(vista==='calificaciones'){ 
            const data = Object.values(formValues);

            if (data.length === 0) {
                Swal.fire('Error', 'No hay cambios que guardar', 'error');
                return;
            }
        
            const response = await axios.post(URL_CALIFICACIONES, { 'modo': 'guardarValoraciones','valoraciones': data });
            console.log(response.data);
            if (!response.data.error) {
                Swal.fire('Éxito', 'Calificaciones guardadas', 'success');
                setValoraciones((prev) =>
                    prev.map((v) =>
                        data.find((d) => d.id_usuario === v.id_usuario && d.id_instancia === v.id_instancia)
                            ? { ...v, ...data.find((d) => d.id_usuario === v.id_usuario && d.id_instancia === v.id_instancia) }
                            : v
                    )
                );
            } else {
                Swal.fire('Error', response.data.message, 'error');
            }
        }
        if(vista==='asistencia'){ 
             const data = Object.values(formValuesAsistencia);

            if (data.length === 0) {
                Swal.fire('Error', 'No hay cambios que guardar', 'error');
                return;
            }
            //console.log('data:'+JSON.stringify(data));
            const response = await axios.post(URL_ASISTENCIA, { 'modo': 'guardarAsistencia', 'fecha':fechaSeleccionada, 'curso':loggeduserCursoGrupo, 'responsable':loggeduserId, 'valores': data });
            //console.log('Asistencia:'+response.data);
            if (!response.data.error) {
                Swal.fire('Éxito', 'Asistencia guardad', 'success');
                setAsistencia((prev) =>
                    prev.map((asis) =>
                        data.find((d) => d.id_usuario === asis.id_usuario && d.fecha === asis.fecha && d.curso === asis.curso)
                            ? { ...asis, ...data.find((d) => d.id_usuario === asis.id_usuario && d.id_instancia === asis.fecha && d.curso === asis.curso) }
                            : asis
                    )
                );
                obtenerAsistencia();
            } else {
                Swal.fire('Error', response.data.message, 'error');
            }            
        }
    };


    return (
    <>
        <div className="container-principal">
            <small>curso: #{loggeduserCurso}</small><small>curso_grupo: #{loggeduserCursoGrupo}</small>
            <h3 className='estudiantes-titulo'>Estudiantes en el curso {estudiantes.length} {rol == 1 && 
                <button type='button' className='btn btn-outline-info btn-sm'>
                    + <i className="fa-solid fa-graduation-cap"></i>
                </button>
            }</h3>
            
            {(rol == 6 || rol == 5) &&
                <div className='row'>
                    <div className="col-12">
                        <ul className="nav nav-tabs justify-content-end">
                            <li className="nav-item">
                                <button 
                                    className={`nav-link ${vista === 'calificaciones' ? 'active' : ''}`} 
                                    onClick={() => handleVistaChange('calificaciones')}
                                >
                                    Calificaciones
                                </button>
                            </li>
                            <li className="nav-item">
                                <button 
                                    className={`nav-link ${vista === 'asistencia' ? 'active' : ''}`} 
                                    onClick={() => handleVistaChange('asistencia')}
                                >
                                    Asistencia
                                </button>
                            </li>
                            <li className="nav-item">
                                <button 
                                    className={`nav-link ${vista === 'actividades' ? 'active' : ''}`} 
                                    onClick={() => handleVistaChange('actividades')}
                                >
                                    Actividades
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            }

            {!visible ? 
                <>
                {estudiantes.length > 0 ? (
                    <form onSubmit={handleSubmit}>
                        <table className="table">
                            <thead>
                            {vista === 'asistencia' &&
                                <tr>
                                    <th colSpan={4}><EstadisticaAsistencia asistencia={asistencia} fechaSeleccionada={fechaSeleccionada}/></th>
                                </tr>
                            }
                            {(rol === 7|| rol ===8) &&
                                <tr>
                                    <th colSpan={3}><EstadisticaAsistencia id_usuario={loggeduserId} asistencia={asistencia} fechaSeleccionada={fechaSeleccionada}/></th>
                                </tr>
                            }
                                <tr>
                                    <th>Estudiante</th>
                                
                                       {vista === 'calificaciones' && (
                                        <MostrarEncabezadoInstancias
                                            curso={loggeduserCurso}
                                            setColInstancias={setColInstancias}
                                        />
                                        )}
                                        {vista === 'asistencia' && (
                                        <>
                                        <td>
                                            <div className='d-flex justify-content-center'>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm me-1"
                                                value={fechaSeleccionada}
                                                onChange={(e) => setFechaSeleccionada(e.target.value)}
                                                max={fechaHoy}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={marcarTodosComoPresentes}
                                            >
                                               Marcar todos Presentes
                                            </button>
                                            </div>
                                        </td>
                                        <td className='text-center'><i className='fa-solid fa-chart-pie'></i></td>
                                        </>
                                        )}
                                    {vista === 'actividades' && (
                                        <MostrarEncabezadosActividades
                                            actividades={actividades}
                                        />
                                    )}
                                    <th className="col-sm-3 col-12 estudiante-botonera">acc.</th>
                                </tr>
                            </thead>
                            <tbody>
                            {estudiantes.map((est) => (
                                <tr key={est.id}>
                                    <td className="col-sm-5 col-12">
                                        <Link to={ `/VerPerfil/e/${est.id}`} className='decoracion-perfil' ><PerfilLogo usuario={est} version="extendida" /></Link>
                                    </td>

                                    {vista === 'calificaciones' &&
                                        colInstancias.map((i, index) => {
                                            const calificacion = valoraciones.find(
                                                (v) => v.id_instancia === i.id && v.id_usuario === est.id
                                            );
                                            const fechaActual = new Date();
                                            const fechaInicio = new Date(i.fecha_inicio);
                                            const fechaCierre = new Date(i.fecha_cierre);

                                            const habilitarInput = fechaActual >= fechaInicio && fechaActual <= fechaCierre;

                                            // Seleccionar el arreglo de opciones basado en el tipo de calificación
                                            let opciones = [];
                                            if (i.tipo_calificacion === 'Valorativa') {
                                                opciones = ['','SC', 'EP', 'S', 'MS', 'Sup'];
                                            } else if (i.tipo_calificacion === 'Numerica') {
                                                opciones = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                                            } else if (i.tipo_calificacion === 'Logro') {
                                                opciones = ['','pendiente', 'Logrado'];
                                            } else if (i.tipo_calificacion === 'Participacion') {
                                                opciones = ['', 'Participo', 'no participo'];
                                            }

                                        return (
                                            <td key={index} className="col text-center">
                                                {(rol == 6 || rol == 5) ?
                                                <select
                                                    className={`estudiante-select-${i.tipo_calificacion.toLowerCase()} ${
                                                        calificacion ? 'estudiante-calificado' : ''
                                                    }`}
                                                    disabled={!habilitarInput}
                                                    value={
                                                         calificacion?.valor
                                                    }
                                                    onChange={(e) =>
                                                        handleSelectChange(est.id, i.id, e.target.value)
                                                    }
                                                >                
                                                   {opciones.map((opcion, idx) => (
                                                        <option key={idx} value={opcion}>
                                                            {opcion}
                                                        </option>
                                                    ))}
                                                </select>
                                                :
                                                <span className='estudiante-nota-texto'>
                                                    {
                                                    calificacion !== null && calificacion !== undefined ? calificacion.valor : '-'
                                                    }
                                                </span>
                                                }
                                            </td>
                                            );
                                        })}
                                        {vista === 'asistencia' && ( 
                                        <>
                                        <td className="">
                                                <select
                                                    value={
                                                        (formValuesAsistencia[`${est.id}_`]?.valor ??
                                                        asistencia.find(a => a.id_usuario === est.id && a.fecha === fechaSeleccionada)?.asistencia) || ''
                                                    } 
                                               
                                                    onChange={(e) =>
                                                        handleSelectInasistenciaChange(est.id, e.target.value)
                                                    }
                                                >
                                                    <option value=""></option>
                                                    <option value="Presente">Presente</option>
                                                    <option value="Ausente">Ausente</option>
                                                    <option value="Tarde">Tarde</option>
                                                </select>
                                                {asistencia.find(a => a.id_usuario === est.id && a.fecha === fechaSeleccionada)?<i className="fa-solid fa-check-circle ms-1"></i> : ''}
                                        </td>
                                        <td><GraficoAsistencia asistenciaAnual={asistenciaAnual} id_usuario={est.id_usuario} /></td>
                                        </>
                                        )}
                                       {vista === 'actividades' && (
                                            actividades.map((actividad, index) => {
                                                const entregaEstudiante = actividad.entregas?.find(e => e.id_estudiante === est.id);
                                                return (
                                                    <td key={index} className="text-center">
                                                        {entregaEstudiante ? (<>
                                                            
                                                            <button
                                                                className="btn btn-success btn-sm"
                                                                onClick={() => {
                                                                    setEntregaSeleccionada({ entregaEstudiante: entregaEstudiante, actividad: actividad });
                                                                }}
                                                                data-bs-toggle="modal" 
                                                                data-bs-target="#exampleModal"
                                                                >
                                                                Sí
                                                            </button>

                                                            </>

                                                        ) : (
                                                            <span className="text-muted">No</span>
                                                        )}
                                                    </td>
                                                );
                                            })
                                        )}

                                        <td className="col-sm-3 col-12 estudiante-botonera">
                                            {(rol == 6 || rol == 5) && (
                                                <button
                                                    type="button"
                                                    className="btn btn-warning btn-sm"
                                                    onClick={() => eliminarEstudiante(est.id)}
                                                >
                                                    - <i className="fa-solid fa-graduation-cap"></i>
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="text-center">
                        {(rol == 6 || rol == 5) && (vista != 'actividades') && 
                            <button type="submit" className="btn btn-primary">
                                Guardar {vista}
                            </button>
                        }
                        </div>
                    </form>
                ) : (
                   <div>Sin estudiantes</div>
                )}                    
                </> 
                : <Espera />
            }
        </div>

        
                
        {/* Modal */}
        <div className="modal fade" 
        id="exampleModal" 
        tabindex="-1" 
        aria-labelledby="exampleModalLabel" 
        aria-hidden="true"
        >
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
            <div className="modal-header">
                <h1 className="modal-title fs-6" id="exampleModalLabel"><i className="fa-solid fa-file-lines"></i> Entrega de actividad</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                {entregaSeleccionada && (
                        <VerEntrega 
                            actividad={entregaSeleccionada.actividad}
                            entregaEstudiante={entregaSeleccionada.entregaEstudiante}
                        />
                )}
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
        </div>
    </>
    );
}

export default Estudiantes;